export const GOOGLE_MAP_API_KEY = 'AIzaSyBjxiXjlbfwB6XYedcmed29xNKQlQPbIAM';
export const RECAPTCHA_ENTERPRISE_INVISIBLE_KEY = '6LcMQSEjAAAAAPWFRMLg7n6NERJhIndKRAbBcoKo';
export const RECAPTCHA_SCRIPT_SRC = 'https://www.google.com/recaptcha/enterprise.js?render=explicit';
export const RECAPTCHA_SCRIPT_SRC_CHINA = 'https://www.recaptcha.net/recaptcha/enterprise.js?render=explicit';
export const GOOGLE_SEARCH_CX_KEY = '368730cd75f71415a';
export const GOOGLE_SEARCH_API_KEY = 'AIzaSyBx70YZuWyyzRfP22ZBpFqLrosyrYrzg08';
export const SENSE_API_KEY = 'ac2ede6c85c393e0ed1c7ccfa3c101698c0a4440';
